import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { LayoutContainerRoutingModule } from './layout-container-routing.module';
import { LayoutContainerComponent } from './layout-container.component';
import { HeaderComponent } from '../components/header/header.component';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { AdminModule } from '../admin.module';

//import { ToastrModule } from 'ngx-toastr';


@NgModule({
  declarations: [LayoutContainerComponent, HeaderComponent, SidebarComponent
],
  imports: [
    CommonModule,
    LayoutContainerRoutingModule,
    RouterModule,
    AdminModule

  //  ToastrModule.forRoot()
  ],
  providers: [
    DatePipe
  ]
})
export class LayoutContainerModule { }
